import { render, staticRenderFns } from "./dataFormProject.vue?vue&type=template&id=ea420cde&scoped=true&"
import script from "./dataFormProject.vue?vue&type=script&lang=js&"
export * from "./dataFormProject.vue?vue&type=script&lang=js&"
import style0 from "./dataFormProject.vue?vue&type=style&index=0&id=ea420cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea420cde",
  null
  
)

export default component.exports